import { useFormikContext } from 'formik'
import {
  useTheme,
  Button,
  FormControl,
  FormHelperText,
  Input,
  InputLabel,
  Typography,
} from '@mui/material'

import { useStyles } from '../styles'
import { HelperWrapper } from 'src/components/helper-wrapper'
import { ETranslationNs } from 'src/types'
import { handleTrimValueOnPaste } from 'src/common/handlers'

const OwnerTransferVerifyForm = () => {
  const { errors, values, handleChange, isSubmitting, setFieldValue } = useFormikContext<{
    code: string
  }>()
  const classes = useStyles()
  const theme = useTheme()

  return (
    <div className={classes.inviteForm}>
      <Typography component="h2" className={classes.inviteModalTitle} align="center">
        <HelperWrapper t="owner-transfer-verify-form-title" />
      </Typography>
      <div className={classes.formInputsWrapper}>
        <FormControl>
          <InputLabel htmlFor="code">
            <HelperWrapper t="verification-code-input-label" ns={ETranslationNs.Form} />*
          </InputLabel>
          <Input
            autoComplete="off"
            value={values.code}
            onChange={handleChange}
            name="code"
            id="code"
            type={'text'}
            onPaste={(event) => handleTrimValueOnPaste(event, values.code, setFieldValue, 'code')}
          />
          <FormHelperText sx={{ color: theme.palette.custom.warning2 }}>
            {errors.code && <HelperWrapper t={errors.code} />}{' '}
          </FormHelperText>
        </FormControl>
      </div>
      <Button disabled={isSubmitting} variant="contained" type="submit">
        <HelperWrapper t="owner-transfer-verify-form-submit" />
      </Button>
    </div>
  )
}

export { OwnerTransferVerifyForm }
